import Box from "@mui/material/Box";
import LoadingSpinner from "../components/layout/LoadingSpinner";
import { Navigate, Outlet } from "react-router-dom";
import { Page } from "@beyondrealityapp/core/shared/constants";
import Typography from "@mui/material/Typography";

type SubscriptionGuardViewProps = {
  allowed: boolean | null;
  isRetrying: boolean;
};

const SubscriptionGuardView: React.FC<SubscriptionGuardViewProps> = ({
  allowed,
  isRetrying,
}) => {
  if (allowed === null) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          width: "100%",
          gap: 2,
        }}
      >
        <LoadingSpinner />
        {isRetrying && (
          <Typography variant="body2" color="text.secondary">
            Setting up your account…
          </Typography>
        )}
      </Box>
    );
  }

  if (!allowed) {
    return <Navigate to={`/${Page.SUBSCRIPTION_BLOCKED}`} replace />;
  }

  return <Outlet />;
};

export default SubscriptionGuardView;
